import l10n from "../../../lang/locallang";
import {fetchRequestSend} from "../../../helpers/common-helpers";
import {
    deleteErrorMessage,
    isUserAnswerInputChecked,
    showErrorMessage
} from "../../../assessments/CreateAssessmentHelpers";

export default class AssessmentMultipleChoicePublic {
    view(response) {
        let popup = document.getElementById('take-assessment-popup');
        return this.createPopupContent(response.content);
    }

    // Escape text before it goes into an HTML attribute so embedded quotes
    // don't truncate data-answer (which breaks answer matching against the backend)
    escapeHtml(text) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text ? String(text).replace(/[&<>"']/g, m => map[m]) : '';
    }

    // Shuffle an array is using the Fisher-Yates algorithm
    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
    createPopupContent(list) {
        const {correctStatus, answer, your, choices} = l10n.customCourse;
        let items = ``;
        if (list) {
            this.shuffleArray(list)
            for (const [key, value] of Object.entries(list)) {
                items += `<li class="choice__item">
                        <div class="choice__your-answer">
                            <input type="radio" id="assessment-multiple-${key}" value="${key}" data-answer="${this.escapeHtml(value.element)}" name="assessment-multiple-choice[]" class="choice__input">
                            <span class="choice__input-icon"></span>
                        </div>
                        <div class="choice__correct-answer is-hidden">
                            <span class="choice__input-icon"></span>
                        </div>
                        <label class="choice__label" for="assessment-multiple-${key}">${this.escapeHtml(value.element)}</label>
                    </li>`;
            }
        }
        return `
        <div class="choice">
            <div class="choice__header">
                <p class="choice__header-item is-your-answer">${your}<br>${answer}</p>
                <p class="choice__header-item is-correct-answer is-hidden">${correctStatus}<br>${answer}</p>
            </div>
            <ul class="choice__list">
                ${items}
            </ul>
        </div>
    `;
    }

    checkError() {
        let result = true;
        let popup = document.querySelector('#take-assessment-popup');
        const {errorMessage} = l10n.assessmentMultipleChoice;
        // if exists error message remove it
        deleteErrorMessage(popup);

        if (!isUserAnswerInputChecked(popup)) {
            // upper .popup-body add error message
            showErrorMessage(popup, errorMessage);
            result = false;
        }
        return result;
    }

    addAnswersList(popup) {
        let answers = [];
        let checkboxes = popup.querySelectorAll('.choice__input');

        checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
                answers.push(checkbox.dataset.answer);
            }
        });

        return answers;
    }

    showResult(data) {
        const popup = document.querySelector('#take-assessment-popup');
        if (!popup) {
            return;
        }
        const assessHint = popup.querySelector('.cg-popup__assess-hint') || popup.querySelector('.assessment-popup-header');
        const {correctStatus, wrongStatus, correctAnswer} = l10n.customCourse;

        if (assessHint) {
            assessHint.innerHTML = correctAnswer;
        }

        if (data.status) {
            if (popup.classList.contains('is-incorrect')) {
                popup.classList.remove('is-incorrect');
            }
            popup.classList.add('is-correct');
            const resultEl = popup.querySelector('.cg-popup__result') || popup.querySelector('.assessment-result');
            if (resultEl) {
                resultEl.innerHTML = `
                    <i class="cg-popup__status-icon"></i>
                    <p class="cg-popup__status-label">${correctStatus}</p>
                `;
            }
        } else {
            if (popup.classList.contains('is-correct')) {
                popup.classList.remove('is-correct');
            }
            popup.classList.add('is-incorrect');
            const resultEl = popup.querySelector('.cg-popup__result') || popup.querySelector('.assessment-result');
            if (resultEl) {
                resultEl.innerHTML = `
                    <i class="cg-popup__status-icon"></i>
                    <p class="cg-popup__status-label">${wrongStatus}</p>
                `;
            }
        }
        let items_list = popup.querySelector('.choice__list');
        if (!items_list) {
            return;
        }
        let items = items_list.querySelectorAll('.choice__item');

        if (data.correctList) {
            const correctHeader = popup.querySelector('.choice__header-item.is-correct-answer');
            if (correctHeader) {
                correctHeader.classList.remove('is-hidden');
            }
            for (let i = 0; i < items.length; i++) {
                items[i].querySelector('.choice__correct-answer').classList.remove('is-hidden');

                if (data.correctList.includes(items[i].querySelector('.choice__input').dataset.answer)) {
                    items[i].querySelector('.choice__correct-answer .choice__input-icon').classList.add('is-correct');
                } else {
                    const userAnswers = [...popup.querySelectorAll('.choice__input')];
                    const isCheckedInputsArray = userAnswers.map(input => input.checked);

                    if (isCheckedInputsArray[i]) {
                        userAnswers[i].parentElement.querySelector('.choice__input-icon').classList.add('is-incorrect');
                    }
                }
            }
        }
    }
}
